export enum PortingBlockingCode {
  PortingIdInvalid = 1,
  PortingRequestInProgress = 2,
  MismatchNameAddressNumber = 22,
  MismatchNumberCustomerId = 27,
  MultipleNumberTypesNotAllowed = 41,
  MultipleDnosDspsNotAllowed = 44,
  NumberNotPortable = 45,
  OutsidePortingWindow = 63,
  Other = 99,
}
